<div class="sample-data-banner" *ngIf="isShowingDemoData">
  <div class="banner-content">
    <span class="banner-text">
      <strong>You're viewing sample data.</strong>
    </span>
    <div class="banner-actions">
      <button class="btn-hide-demo" (click)="removeSampleData()" [disabled]="isRemoving">
        {{ isRemoving ? 'Exiting…' : 'Hide sample data' }}
      </button>
    </div>
    <button class="close-btn" (click)="closeBanner()" aria-label="Exit sample data" title="Exit sample data">✖</button>
  </div>
</div>
